import React from 'react';
import { ResponsiveContainer, AreaChart, Area as ReArea, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';

import { ChartsHeader } from '../../components';
import { areaCustomSeries } from './data';
import { useStateContext } from '../../contexts/ContextProvider';

export const Area = () => {
  const { currentMode } = useStateContext();

  // Merge areaCustomSeries.dataSource into a single array with keys per series
  const seriesNames = areaCustomSeries.map((s: any, i: number) => s.name || `series${i}`);
  const combined: any[] = [];
  if (areaCustomSeries && areaCustomSeries.length > 0) {
    const len = areaCustomSeries[0].dataSource.length;
    for (let i = 0; i < len; i++) {
      const row: any = { date: areaCustomSeries[0].dataSource[i].x };
      areaCustomSeries.forEach((series: any, si: number) => {
        row[seriesNames[si]] = series.dataSource[i] ? series.dataSource[i].y : null;
      });
      combined.push(row);
    }
  }

  const colors = ['#8884d8', '#82ca9d', '#ffc658'];

  return (
    <div className="m-4 md:m-10 mt-24 p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl">
      <ChartsHeader category="Área" title="Taxa de Inflação (%)" />
      <div className="w-full" style={{ width: '100%', height: 360, background: currentMode === 'Dark' ? '#33373E' : '#fff', padding: 8, borderRadius: 6 }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={combined}>
            <CartesianGrid strokeDasharray="3 3" stroke={currentMode === 'Dark' ? '#444' : '#e6e6e6'} />
            <XAxis dataKey="date" tickFormatter={(d) => {
              try { const dt = new Date(d); return dt.getFullYear(); } catch { return d; }
            }} tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
            <YAxis tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
            <Tooltip contentStyle={{ backgroundColor: currentMode === 'Dark' ? '#1f2937' : '#fff', borderRadius: 6 }} />
            <Legend wrapperStyle={{ color: currentMode === 'Dark' ? '#eee' : '#333' }} />
            {seriesNames.map((name: string, idx: number) => (
              <ReArea key={name} type="monotone" dataKey={name} stroke={colors[idx % colors.length]} fill={colors[idx % colors.length]} />
            ))}
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
